import parse, { domToReact } from "html-react-parser";
import Tooltip from "components/Elements/Tooltip/Tooltip";
import Icon from "components/Elements/Icon/Icon";
import { useContent } from "contexts/contentContext/contentContext";
import useMediaQueries from "hooks/useMediaQueries";

interface PlansCardFeaturesI {
  constKey: string;
}

interface DomElementI {
  attribs?: { [key: string]: string };
  name?: string;
  children?: DomElementI[];
  // Add other properties as needed
}

interface DomElementOptionsI {
  replace?(element: DomElementI): JSX.Element | undefined;
}
const PlansCardFeatures = ({ constKey }: PlansCardFeaturesI) => {
  const { getTextByKey } = useContent();
  const { mobileCondition } = useMediaQueries();

  if (!constKey) return null;

  const options: DomElementOptionsI = {
    replace({ attribs, name, children }) {
      if (!name) {
        return;
      }

      if (name === "tooltip" && attribs?.tooltiptext) {
        return (
          <Tooltip
            tooltipText={attribs.tooltiptext.replace(/[{"}]/g, "")}
            mobileClickability
            top={mobileCondition}
            hardPositionedPosition={mobileCondition}
          >
            {domToReact(children, options)}
          </Tooltip>
        );
      }

      if (name === "icon" && attribs?.name) {
        const keys = Object.keys(attribs)
        return <Icon blue={keys.some(key => key === "blue")} disabledgray={keys.some(key => key === "disabledgray")} name={attribs.name} />;
      }
    },
  };

  return (
    <ul className="plans-card-features">
      {parse(getTextByKey(constKey), options)}
    </ul>
  );
};

export default PlansCardFeatures;
